import { getAdvertisement } from 'config/api';
import { useQuery } from 'react-query';

export type AdvertisementRead = {
  id: string;
  readDay: string | null; // yyyymmdd
  hidden: boolean;
};

export type AdvertisementProps = {
  id: string;
  category: string;
  title: string;
  content: string;
  imageUrl: string;
  contentUrl: string;
  buttonTitle: string;
};

export const getAdvertisementReadStorage = (): AdvertisementRead[] | null => {
  const userJson = localStorage.getItem('advertisementRead');
  return userJson ? (JSON.parse(userJson) as AdvertisementRead[]) : null;
};

export const setAdvertisementReadStorage = (list: AdvertisementRead[]) => {
  localStorage.setItem('advertisementRead', JSON.stringify(list));
};

export const useAdvertisement = () => {
  const { data } = useQuery('getAdvertisement', () => getAdvertisementAPI(), {
    refetchOnWindowFocus: false,
  });

  return { advertisements: data };
};

const getAdvertisementAPI = async () => {
  const ret_ = await getAdvertisement();
  const ret = ret_.Items.map(item => {
    return {
      id: item.ID,
      category: item.Category,
      title: item.Title,
      content: item.Content,
      imageUrl: item.ImageUrl,
      contentUrl: item.ContentUrl,
      buttonTitle: item.ButtonTitle,
    };
  }) as AdvertisementProps[];
  return ret;
};
